if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.mainBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.stickyBtn = this.querySelector('.sticky-atc__btn');
        this.variantLabel = this.querySelector('.sticky-atc__variant-text');
        this.price = this.querySelector('.sticky-atc__price');
        this.observer = null;
      }

      connectedCallback() {
        if (!this.mainBtn || !this.stickyBtn) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => this.toggleVisibility(!entry.isIntersecting));
          },
          { threshold: 0, rootMargin: '0px 0px -10px 0px' }
        );
        this.observer.observe(this.mainBtn);

        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.sectionId !== this.sectionId) return;
          this.onVariantChange(event.data.variant, event.data.html);
        });

        this.stickyBtn.addEventListener('click', this.onStickyClick.bind(this));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.body.classList.remove('sticky-atc-is-visible');
      }

      toggleVisibility(show) {
        this.setAttribute('aria-hidden', String(!show));
        this.classList.toggle('sticky-atc--visible', show);
        document.body.classList.toggle('sticky-atc-is-visible', show);
        if (show) document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
      }

      onVariantChange(variant, html) {
        if (this.variantLabel) {
          const label = variant && variant.title !== 'Default Title' ? variant.title : '';
          this.variantLabel.textContent = label;
        }

        const priceSource = html?.getElementById(`price-${this.sectionId}`);
        if (priceSource && this.price) this.price.innerHTML = priceSource.innerHTML;

        if (!variant || !variant.available) {
          this.stickyBtn.disabled = true;
          this.stickyBtn.textContent = variant
            ? window.variantStrings.soldOut
            : window.variantStrings.unavailable;
        } else {
          this.stickyBtn.disabled = false;
          this.stickyBtn.textContent = window.variantStrings.addToCart;
        }
      }

      onStickyClick() {
        if (this.stickyBtn.disabled) return;

        const mainSubmitBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!mainSubmitBtn || mainSubmitBtn.disabled || mainSubmitBtn.getAttribute('aria-disabled') === 'true') return;

        this.stickyBtn.classList.add('loading');
        this.stickyBtn.setAttribute('aria-busy', 'true');

        let timeoutId;
        let unsubscribeCart = () => {};
        let unsubscribeError = () => {};
        const cleanupLoading = () => {
          clearTimeout(timeoutId);
          this.stickyBtn.classList.remove('loading');
          this.stickyBtn.removeAttribute('aria-busy');
          unsubscribeCart();
          unsubscribeError();
        };

        unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, cleanupLoading);
        unsubscribeError = subscribe(PUB_SUB_EVENTS.cartError, cleanupLoading);

        timeoutId = setTimeout(cleanupLoading, 12000);

        mainSubmitBtn.click();
      }
    }
  );
}
